export const MIN_LOOKUP_DATE_FOR_HOWS_MY_DRIVING_NY_LOOKUPS = '2018-03-22'
